export default function GuildSwitcher({ guilds, selected, onSelect }) {
  if (!guilds?.length) {
    return (
      <div className="card p-4 text-sm text-slate-400" data-testid="no-guilds">
        Bot nie jest jeszcze na żadnym serwerze — użyj przycisku „Zaproś bota”.
      </div>
    );
  }
  return (
    <div className="flex gap-2 overflow-x-auto pb-1" data-testid="guild-selector">
      {guilds.map((g) => (
        <button
          key={g.id}
          onClick={() => onSelect(g.id)}
          data-testid={`guild-pill-${g.id}`}
          className={`flex items-center gap-2 rounded-full pl-1 pr-4 py-1 border text-sm whitespace-nowrap transition-colors ${
            selected === g.id
              ? "border-emerald-500/60 bg-emerald-500/10 text-emerald-200"
              : "border-slate-800 bg-slate-900/70 text-slate-300 hover:border-slate-600"
          }`}
        >
          {g.icon ? (
            <img src={g.icon} alt="" className="h-7 w-7 rounded-full" />
          ) : (
            <span className="h-7 w-7 rounded-full bg-slate-800 grid place-items-center font-heading font-bold text-xs">
              {g.name.slice(0, 2).toUpperCase()}
            </span>
          )}
          {g.name}
          {g.playing && <span className="h-1.5 w-1.5 rounded-full bg-emerald-400 pulse-dot" />}
        </button>
      ))}
    </div>
  );
}
